import * as React from "react";
import {Grid} from "tabler-react";
import SiteWrapper from "../../SiteWrapper.react";
import Catalogo from "../../components/Catalogo";
import {RolesForm}  from "../../Catalogos";
import { GetRoles } from "../../herramientas/JWT";
function RolesPage() {
  if(!GetRoles().includes("root",))
    window.history.back();
  return (
    <SiteWrapper>
        <Grid.Col sm={12} lg={12}> 
          <Catalogo
            titulo="Roles"
            tamanio="45%"
            FCtlogo= { RolesForm }
            catalogo= "roles"
            columnas= {
              [
                { columna: "id", label:"ID" },
                { columna: "nombre", label:"NOMBRE" },
                { columna: "descripcion", label:"DESCRIPCIÓN" },
              ]
            }
          />
        </Grid.Col>
    </SiteWrapper>
  );
}
export default RolesPage;
